/**
 * Created by Pradeep Kumar on 7/11/2019.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {TombOfNefertitiGameShaker} from "../../gameshake/TombOfNefertitiGameShaker";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";

export class TombOfNefertitiWildRaidPresentationView extends BaseView {
    private _fire:TimelineSprite[] = [];
    private _wildOverlays:PIXI.Sprite[] = [];

    private _bgOverlay:PIXI.Graphics;
    private _wildRaider:PIXI.Sprite;
    private _gameConfigInstance:TombOfNefertitiGameConfig = TombOfNefertitiGameConfig.instance;
    private _layer:PIXI.Container;
    private _tl:TimelineLite | null = null;
    private _endTl:TimelineLite | null = null;
    private _numOfMiddleReels:number = 9;

    private _wildRaidPositions:number[];

    private _loopSoundPlayed:boolean = false;
    private _lockSoundPlayed:boolean = false;

    private _isWildRaiderShown:boolean = false;

    public static _wildRaidContainer:TombOfNefertitiWildRaidPresentationView;

    set wildRaidPositions(value:number[]) {
        this._wildRaidPositions = value;
    }

    public killTimeLine(mode: string): void {
        if(this._tl) {
            this._tl!.kill();
            this._tl = null;
        }
        if(this._endTl) {
            this._endTl!.kill();
            this._endTl = null;
        }

        SlotGame.sound.stopEffect(TombOfNefertitiSoundConfig.instance.RAIDER_FLAME_LOOP);

        for(let i:number = 0; i < this._numOfMiddleReels; ++i) {
            this._fire[2 * i].alpha = 0;
            this._fire[2 * i + 1].alpha = 0;
        }

        this._bgOverlay.visible = false;
        for(let i:number = 0; i < this._wildOverlays.length; ++i) {
            this._wildOverlays[i].scale.set(1);
        }

        if(!this._isWildRaiderShown && (mode === GameMode.NORMAL)) {
            TweenLite.to(this._wildRaider, 0.2, {
                alpha : 1,
                onComplete : () => {
                    TweenLite.to(this._wildRaider, 0.2, {
                        alpha : 0
                    });
                }
            });

            this._isWildRaiderShown = false;
            return;
        }

        this._isWildRaiderShown = false;

        TweenLite.to(this._wildRaider, 0.5, {
            alpha : 0
        });
    }

    // todo check if this method can be optimized(reduce the loop pattern)
    public playAnim(mode:string):void {
        this._tl = new TimelineLite();
        this._loopSoundPlayed = false;
        this._lockSoundPlayed = false;

        let speedSaleFactor:number = 1;

        if(GameSetting.isFastSpin) {
            speedSaleFactor = 2;
        }

        let alphaDur:number = 0.5,
            timeToStartAlphaOff:number = 1.5,
            totalFramesInOneCycle:number = 15,
            fps:number = 30,
            startDelay:number = mode.indexOf(GameMode.FREESPIN) !== -1 ? -1 : 1,
            scaleDuration:number = 0.3,
            delayToCallScale:number = mode.indexOf(GameMode.FREESPIN) !== -1 ? 0.75 : 2;

        // show wild raider image in main game only
        if(mode === GameMode.NORMAL) {
            this._tl.add(() => {
                SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.RAIDER_TRIGGER);
                this._bgOverlay.visible = true;

                this._isWildRaiderShown = true;
                TweenLite.to(this._wildRaider, alphaDur / speedSaleFactor, {
                    alpha : 1
                });
            }, startDelay / speedSaleFactor);

            this._tl.add(() => {
                this._bgOverlay.visible = false;

                TweenLite.to(this._wildRaider, alphaDur / speedSaleFactor, {
                    alpha : 0
                });
            }, timeToStartAlphaOff / speedSaleFactor + startDelay / speedSaleFactor);
        }

        for(let i:number = 0; i < this._numOfMiddleReels; ++i) {
            this._tl.add(() => {
                if(i === 0) {
                    SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.RAIDER_FLAME_APPEAR);
                }
                (this._fire[2 * i] as any)._textures = GameResources.getTextures("fireStartInnerWhite");
                this._fire[2 * i].visible = true;
                this._fire[2 * i].alpha = 1;
                this._fire[2 * i].getAnimation();

                (this._fire[2 * i + 1] as any)._textures = GameResources.getTextures("fireStartGreyScale");
                this._fire[2 * i + 1].visible = true;
                this._fire[2 * i + 1].alpha = 1;
                this._fire[2 * i + 1].getAnimation();
            }, (timeToStartAlphaOff + alphaDur + startDelay) / speedSaleFactor);

            if(this._wildRaidPositions.indexOf(i + 1) !== -1) {
                this._tl.add(() => {
                    if(!this._loopSoundPlayed) {
                        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.RAIDER_FLAME_LOOP, -1);
                        this._loopSoundPlayed = true;
                    }
                    (this._fire[2 * i] as any)._textures = GameResources.getTextures("fireLoopInnerWhite");
                    this._fire[2 * i].playLoop();

                    (this._fire[2 * i + 1] as any)._textures = GameResources.getTextures("fireLoopGreyScale");
                    this._fire[2 * i + 1].playLoop();
                }, ((totalFramesInOneCycle / fps) + timeToStartAlphaOff + alphaDur + startDelay) / speedSaleFactor);
            } else {
                this._tl.add(() => {
                    (this._fire[2 * i] as any)._textures = GameResources.getTextures("fireLoopInnerWhite");
                    this._fire[2 * i].getAnimation();

                    (this._fire[2 * i + 1] as any)._textures = GameResources.getTextures("fireLoopGreyScale");
                    this._fire[2 * i + 1].getAnimation();
                }, ((totalFramesInOneCycle / fps) + timeToStartAlphaOff + alphaDur + startDelay) / speedSaleFactor);
                this._tl.add(() => {
                    if(!this._lockSoundPlayed) {
                        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.RAIDER_FLAME_LOCK);
                    }

                    TweenLite.to(this._fire[2 * i], alphaDur, {
                        alpha : 0
                    });
                    TweenLite.to(this._fire[2 * i + 1], alphaDur, {
                        alpha : 0
                    });
                }, (2 * (totalFramesInOneCycle / fps) + timeToStartAlphaOff + alphaDur + startDelay) / speedSaleFactor);
            }
        }

        for(let i:number = 0; i < this._wildOverlays.length; ++i) {
            this._tl.add(() => {
                if(this._wildRaidPositions.indexOf(i + 1) !== -1) {
                    this._wildOverlays[i].visible = true;
                    this._wildOverlays[i].scale.set(7);

                    if(!this._lockSoundPlayed) {
                        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.WILD_RAIDER_LANDING);
                        this._lockSoundPlayed = true;
                    }
                    TweenLite.to(this._wildOverlays[i].scale, scaleDuration / speedSaleFactor, {
                        x : 1,
                        y : 1,
                        onComplete : () => {
                            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.START_GAME_SHAKING_REEL_AREA));
                            TweenLite.to(() => {}, 0.3, {
                                onComplete : () => {
                                    EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiGameShaker.STOP_GAME_SHAKING));
                                }
                            });
                        }
                    });
                }
            }, ((2.5 * (totalFramesInOneCycle / fps) + timeToStartAlphaOff + alphaDur + startDelay + delayToCallScale)) / speedSaleFactor);
        }

        this._tl.play();
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(this._gameConfigInstance.LAYERS.WILD_RAID.name);
        this._layer.addChild(this);

        this.createWildRaider();

        let whiteItem:TimelineSprite,
            fire:TimelineSprite,
            wildOverlay:PIXI.Sprite,
            pos:number[];

        for(let i:number = 0; i < this._numOfMiddleReels; ++i) {
            pos = Helper.getSymbolPositions(i + 3, 0);

            whiteItem = new TimelineSprite(GameResources.getTextures("fireStartInnerWhite"));
            fire = new TimelineSprite(GameResources.getTextures("fireStartGreyScale"));

            whiteItem.anchor.set(0.5);
            whiteItem.position.set(pos[0], pos[1]);
            whiteItem.visible = false;
            whiteItem.alpha = 0;
            whiteItem.blendMode = PIXI.BLEND_MODES.ADD;

            fire.anchor.set(0.5);
            fire.position.set(pos[0], pos[1]);
            fire.visible = false;
            fire.alpha = 0;
            fire.blendMode = PIXI.BLEND_MODES.ADD;
            fire.tint = 0xFF0000;

            wildOverlay = new PIXI.Sprite(GameResources.getTextures("symbols/W/W")[0]);
            wildOverlay.anchor.set(0.5);
            wildOverlay.position.set(pos[0], pos[1] - (this._gameConfigInstance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - this._gameConfigInstance.SYMBOL_HEIGHT) / 2);
            wildOverlay.visible = false;

            this.addChild(whiteItem);
            this.addChild(fire);
            this.addChild(wildOverlay);
            this._fire.push(whiteItem);
            this._fire.push(fire);
            this._wildOverlays.push(wildOverlay);
        }

        TombOfNefertitiWildRaidPresentationView._wildRaidContainer = this;
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, SpinReelEvent.REEL_STOP_SPIN_BOUNCE_STARTED, (event:GameEvent) => this.stopFire((event.params[0])));
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => {
            for(let i:number = 0; i < this._wildOverlays.length; ++i) {
                this._wildOverlays[i].visible = false;
            }
        });
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize && super.onResize(resizeData);

        const stageCenter:number[] = Helper.getSymbolPositions(Math.floor(TombOfNefertitiGameConfig.instance.REELS_NUM / 2), 0),
            portraitOffset:number = 32,
            landscapeOffset:number = 100;

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._wildRaider.scale.set(0.75);
            this._wildRaider.position.set(stageCenter[0], stageCenter[1] + portraitOffset);
        } else {
            this._wildRaider.scale.set(1);
            this._wildRaider.position.set(stageCenter[0], stageCenter[1] + landscapeOffset);

        }
    }

    private createWildRaider():void {
        let wildRaider:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("WildRaider")[0]);

        const offset:number = 60;

        wildRaider.anchor.set(0.5);
        wildRaider.alpha = 0;

        this._bgOverlay = new PIXI.Graphics();
        this._bgOverlay.beginFill(0x000000, 0.85);
        this._bgOverlay.drawRect(this._gameConfigInstance.REEL_AREA_POS_X + offset, this._gameConfigInstance.REEL_AREA_POS_Y, this._gameConfigInstance.REEL_AREA_WIDTH - (2 * offset), this._gameConfigInstance.REEL_AREA_HEIGHT);
        this._bgOverlay.endFill();
        this._bgOverlay.visible = false;

        this.addChild(this._bgOverlay);
        this.addChild(wildRaider);

        this._wildRaider = wildRaider;
    }

    private stopFire(data:IReelStoppedData):void {
        if(this._wildRaidPositions.length === 0) {
            return;
        }

        const lastReelId:number = this._gameConfigInstance.REELS_NUM - 1,
            duration:number = 0.5;

        if(data.reelId === lastReelId) {
            SlotGame.sound.stopEffect(TombOfNefertitiSoundConfig.instance.RAIDER_FLAME_LOOP);

            for(let i:number = 0; i < this._fire.length; ++i) {
                TweenLite.to(this._fire[i], duration, {
                    alpha : 0
                });
            }

            this._endTl = new TimelineLite({
                onComplete : () => {
                    this._endTl!.pause();
                    this._endTl!.kill();
                    this._endTl = null;
                }
            });
            this._endTl.add(() => {
                for(let i:number = 0; i < this._fire.length; ++i) {
                    this._fire[i].stopLoop();
                    this._fire[i].visible = false;
                }
            }, duration);

            for(let i:number = 0; i < this._wildOverlays.length; ++i) {
                this._wildOverlays[i].visible = false;
            }
        }
    }
}